export enum NotificationsEnum {
  Group = 'Group',
  Chat = 'Chat',
  Follower = 'Follower',
  Job = 'Job',
}
